import Header from '../../components/Header'
import HeaderImage from '../../img/georges.jpg'

import { MdEmail } from 'react-icons/md'
import { BsMessenger } from 'react-icons/bs'
import { IoLogoWhatsapp } from 'react-icons/io'

import './gallery.css'
const Gallery = () => {
const galleryLength= 30

const image =[]
for (let i = 1; i <= galleryLength; i++) {
    image.push(require(`../../img/gallerie${i}.jpg`))
    
}

    return (
        <>
            <Header title="Bienvenue dans Notre Gallerie" image={HeaderImage} >
                Découvrez notre incroyable galerie d'images qui capturent des moments spéciaux et inspirants. Plongez dans un monde visuel captivant où vous pourrez explorer des paysages époustouflants, des portraits expressifs, des événements passionnants et bien plus encore. Laissez-vous emporter par la beauté et l'émotion de nos photographies exceptionnelles.
            </Header>
            <section className="gallery">
                <div className='container gallery__container' >
                    {
                        image.map((image, index)=>{
                            return <article key={index} >
                                   <img src={image} alt={`Gallerie Image ${index} +1`} />
                            </article>
                        })
                    }
                </div>


            </section>
        </>
       
    )
}

export default Gallery













